import { Navigate } from "react-router-dom";
import { APP_DEFAULT_PATH } from "@/constants/navigation";

export default function IndexPage() {
  return <Navigate to={APP_DEFAULT_PATH} replace />;
}
